// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Loader, Toastr, Tooltip, Button, Input } from "@revvsales/components";

// Components Imports
import { ConfirmationBoxV2 } from "../../../commonComponents";
import AssetItems from "./AssetItems";
import AssetMoveToFolderPopup from "./AssetMoveToFolderPopup";
import AssetCustomizeColumnPopup from "./AssetCustomizeColumnPopup";
import AssetItemRenamePopup from "./AssetItemRenamePopup";
import AssetCollaboratorPopup from "./AssetCollaboratorPopup";
import AssetCreateDocumentPopup from "../AssetHeader/AssetCreateDocumentPopup";
import AssetSearchTags from "./AssetSearchTags";
import MetalensBulkDownloadSuccessPopup from "../../DocumentApprovalPopupNew/MetadataBulkDownloadSuccessPopup";
import QuickReviewIcon from "../../QuickReview/QuickReviewIcon";

// Actions Imports
import { AssetActions } from "../../../actions";

// Services Imports
import { metadataBulkDownloadService } from "../../../actions/MetalensActions/metalensServices";

// Internal Imports
import { GlobalUtils, AmplitudeUtils, MetalensUtils } from "../../../utils";
import { ASSET, EVENTS, LOADING_MSG } from "../../../constants";
// Commented sorting icons and dropdown for next release
// import AssetFilter from "./AssetFilter";
// import StatusFilter from "./AssetFilter/StatusFilter";
import { checkAssetPermission } from "../method";

// Destructuring
const {
  handleApiErrMsg,
  writeDataToLocalStorage,
  readDataFromLocalStorage,
  removeDataFromLocalStorage,
} = GlobalUtils;
const {
  deleteAssetItemsAction,
  getAssetFolderContentAction,
  assetClearSearchTermAction,
  updateDocumentList,
} = AssetActions;
const { ASSET_COLUMN_CONFIG, ASSET_ITEM_TYPES } = ASSET;
const { amplitudeLogEvent } = AmplitudeUtils;
const {
  ASSET: { DELETE_ITEM },
} = LOADING_MSG;
const { downloadObject: downloadMetadataObject } = MetalensUtils;

class AssetDetails extends Component {
  state = {
    assetColumns: [...ASSET_COLUMN_CONFIG],
    filters: { status: false, tags: false },
    isAllAssetItemsSelected: false,
    selectedCheckboxItems: {},
    selectedItem: null,
    showAssetCollaboratorPopup: false,
    showAssetItemRenamePopup: false,
    showCreateDocPopUp: false,
    showCustomizeColumnPopup: false,
    showDeleteItemsPopup: false,
    showLoader: false,
    showMoveToFolderPopup: false,
    showDeleteItemBtnLoader: false,
    showMetalensDownloadSuccessPopup: false,
    totalDocumentsDownloaded: 0,
    metalensLoaderMessage: "",
  };

  componentDidMount() {
    const assetColumns = readDataFromLocalStorage("assetCustomColumns");
    if (assetColumns) {
      this.setState({
        assetColumns,
      });
    }
    document.addEventListener("click", this._handleStatusFilterOutsideClick);
    this._getAssetItems();
    removeDataFromLocalStorage("docNo");
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.folderID !== prevProps.folderID ||
      this.props.currentView !== prevProps.currentView
    ) {
      this._getAssetItems();
      // Search related: On change of this, test for search
      if (this.props.showSearchPage) {
        // args passed: flag=false , changeFolder=true
        this.props.toggleSearchPage(false, true);
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this._handleStatusFilterOutsideClick);
  }

  _getAssetItems = () => {
    const { folderID, opportunityId, currentView } = this.props;
    let payload = null;
    const assetDataToFetch = folderID ? "all" : currentView;
    if (folderID) {
      payload = `parent_id=${folderID}`;
      if (opportunityId) {
        payload = `parent_id=${folderID}&opp_id=${opportunityId}`;
      }
    }
    this.setState({
      selectedCheckboxItems: {},
      showLoader: true,
      selectedItem: null,
    });
    this.props
      .getFolderContent(payload, folderID || null, assetDataToFetch)
      .then(() => {
        this._toggleCustomLoader("showLoader", false);
      })
      .catch(error => {
        console.error(`AssetDetails => _getFolderContent => Error : ${error}`);
        this._toggleCustomLoader("showLoader", false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _toggleCustomLoader = (type, flag) => {
    this.setState({ [type]: flag, selectedItem: null });
  };

  _openActionDropdown = (type, flag, data) => {
    if (type === "clone") {
      this._toggleCustomLoader("showLoader", true);
      this.props
        .updateDocumentList(data)
        .then(() => {
          const message = "Document successfully cloned";
          Toastr.showToastr({
            type: "success",
            message,
            timeout: 2000,
          });
          this._toggleCustomLoader("showLoader", false);
        })
        .catch(error => {
          const message = handleApiErrMsg(error);
          Toastr.showToastr({
            type: "failure",
            message,
            timeout: 2000,
          });
          this._toggleCustomLoader("showLoader", false);
        });
    } else {
      this.setState({ [type]: flag, selectedItem: data });
    }
  };

  _closeDeleteItemsPopup = () => {
    this.setState({ showDeleteItemsPopup: false, selectedItem: null });
  };

  _selectAssetItem = (selectedID, data, isAnyItemSelected) => {
    const { selectedCheckboxItems } = this.state;
    let cloneSelectedItems = { ...selectedCheckboxItems };
    if (data.type === "ALL") {
      if (isAnyItemSelected) {
        cloneSelectedItems = {};
      } else {
        const { assetFolderContent } = this.props;
        if (
          assetFolderContent &&
          assetFolderContent.page &&
          assetFolderContent.page.inodes.length > 0
        ) {
          assetFolderContent.page.inodes.forEach(inode => {
            const type =
              inode.access_level === "EDIT" ? "DISABLE_CHECKBOX" : null;
            const hasCheckboxSelectPermission = checkAssetPermission(
              inode.access_level,
              type,
            );
            if (
              hasCheckboxSelectPermission &&
              (!(inode.opportunity_id && inode.opportunity_root) &&
                inode.type !== ASSET_ITEM_TYPES.EXTERNAL_QUOTE)
            ) {
              cloneSelectedItems[inode.id] = {
                flag: true,
                type: inode.type,
                parentId: inode.parent_id,
                name: inode.name,
                docId: inode.file_id,
              };
            }
          });
        }
      }
    } else if (cloneSelectedItems[selectedID] === undefined) {
      cloneSelectedItems[selectedID] = { ...data };
    } else {
      delete cloneSelectedItems[selectedID];
    }

    this.setState({ selectedCheckboxItems: cloneSelectedItems });
  };

  _getSelectedItemData = () => {
    const { selectedCheckboxItems } = this.state;
    let isAnyItemSelected = false;
    let count = 0;
    const selectedItems = { items: [], ids: [], parentId: null, docIds: [] };
    this.props.assetFolderContentIds.forEach(assetItemId => {
      if (selectedCheckboxItems[assetItemId] !== undefined) {
        const tempItem = selectedCheckboxItems[assetItemId];
        isAnyItemSelected = true;
        count += 1;
        selectedItems.ids.push(assetItemId);
        if (!selectedItems.parentId) {
          selectedItems.parentId = tempItem.parentId;
        }
        if (tempItem.docId) {
          selectedItems.docIds.push(tempItem.docId);
        }
        selectedItems.items.push({
          id: assetItemId,
          type: tempItem.type,
          name: tempItem.name,
        });
      }
    });
    return { isAnyItemSelected, count, selectedItems };
  };

  _deleteAssetItems = selectItems => {
    if (selectItems && selectItems.items && selectItems.items.length > 0) {
      const { ids, items } = selectItems;
      const payload = { ids: [...ids] };
      this.setState({
        showDeleteItemBtnLoader: true,
      });
      this.props
        .deleteAssetItems(payload, selectItems)
        .then(() => {
          // Decide the item name for toastr message
          let itemName = "Selected Items";
          if (items.length === 1) {
            itemName = items[0].name || items[0].folderName;
          }
          Toastr.showToastr({
            type: "success",
            message: `${itemName} deleted successfully.`,
            timeout: 3000,
          });
          setTimeout(() => {
            this.setState({
              selectedCheckboxItems: {},
              showDeleteItemsPopup: false,
              showDeleteItemBtnLoader: false,
            });
          }, 200);
          // Amplitude event call for "Delete Folder"
          if (items[0].folderType === "d" || items[0].type === "d") {
            amplitudeLogEvent(EVENTS.EVENT_NAMES.FOLDER_DELETED, {
              initiatedFrom: "Asset",
              folderId: items[0].folderId || items[0].id,
            });
          }
          // Amplitude event call for "Delete Document"
          else {
            amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_DELETED, {
              initiatedFrom: "Asset",
            });
          }
        })
        .catch(error => {
          console.error(
            `AssetDetails => _deleteAssetItems => Error : ${error}`,
          );
          let errorMsg = "Something went wrong. Please try again!";
          if (error && error.response && error.response.status === 403) {
            errorMsg =
              "Either the folder is not empty or you do not have permission to delete the contents.";
          } else if (this.props.showSearchPage) {
            errorMsg =
              "Bulk delete is not allowed for items belonging to multiple folders";
          }
          Toastr.showToastr({
            type: "failure",
            message: errorMsg,
            timeout: 3000,
          });
          this.setState({
            showDeleteItemsPopup: false,
            showDeleteItemBtnLoader: false,
          });
        });
    }
  };

  _handleStatusFilterOutsideClick = event => {
    if (this.statusFilterRef && !this.statusFilterRef.contains(event.target)) {
      this.setState({
        filters: {
          status: false,
        },
      });
    }
  };

  _setFilterRef = (node, type) => {
    if (type === "status") {
      this.statusFilterRef = node;
    }
  };

  _toggleFilterDropdown = type => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [type]: !filters[type],
      },
    });
  };

  _switchColumnHeader = (id, label, isActive) => {
    if (isActive) {
      switch (id) {
        case "tagsType":
          return (
            <div className="assetdetails-col col-type" key={id}>
              <span className="assetdetails-table-text">
                {label}
                {/* <FontAwesomeIcon
                  icon={["fas", "sort"]}
                  className="assetdetails-down-icon"
                /> */}
              </span>
            </div>
          );
        case "status":
          return (
            <div
              ref={node => this._setFilterRef(node, "status")}
              key={id}
              className="assetdetails-col col-status assetdetails-filter">
              <span
                // role="button"
                // tabIndex="0"
                // onKeyPress={() => {}}
                // onClick={() => this._toggleFilterDropdown("status")}
                className="assetdetails-table-text">
                {label}
                {/* <FontAwesomeIcon
                  icon={["fas", "angle-down"]}
                  className="assetdetails-menu-icon"
                /> */}
              </span>
              {/* <AssetFilter show={this.state.filters.status}>
                <StatusFilter />
              </AssetFilter> */}
            </div>
          );
        case "modifiedBy":
          return (
            <div className="assetdetails-col col-modify" key={id}>
              <span className="assetdetails-table-text">
                {label}
                {/* <FontAwesomeIcon
                  icon={["fas", "sort"]}
                  className="assetdetails-down-icon"
                /> */}
              </span>
            </div>
          );
        case "docuId":
          return (
            <div className="assetdetails-col col-docuid" key={id}>
              <span className="assetdetails-table-text">
                {label}
                {/* <FontAwesomeIcon
                  icon={["fas", "sort"]}
                  className="assetdetails-down-icon"
                /> */}
              </span>
            </div>
          );
        case "contact":
          return (
            <div className="assetdetails-col col-contact" key={id}>
              <span className="assetdetails-table-text">
                {label}
                {/* <FontAwesomeIcon
                  icon={["fas", "sort"]}
                  className="assetdetails-down-icon"
                /> */}
              </span>
            </div>
          );
        case "turnarounddate":
          return (
            <div className="assetdetails-col col-turnarounddate" key={id}>
              <span className="assetdetails-table-text">
                {label}
                {/* <FontAwesomeIcon
                  icon={["fas", "sort"]}
                  className="assetdetails-down-icon"
                /> */}
              </span>
            </div>
          );
        default:
          return null;
      }
    } else {
      return null;
    }
  };

  _getAssetItemsTableHeader = () => (
    <div className="assetdetails-row">
      <div className="assetdetails-col col-title">
        <span className="assetdetails-table-text">
          Title
          {/* <FontAwesomeIcon
            icon={["fas", "sort"]}
            className="assetdetails-down-icon"
          /> */}
        </span>
      </div>
      {/* for column customisation */}
      {this.state.assetColumns &&
        this.state.assetColumns.map(column =>
          this._switchColumnHeader(column.id, column.label, column.isActive),
        )}
      <Tooltip
        placement="left"
        overlay="Customize columns"
        align={{
          offset: [4, 0],
        }}>
        <div
          className="assetdetails-add-btn"
          onClick={() =>
            this._toggleCustomLoader("showCustomizeColumnPopup", true)
          }
          onKeyPress={() => {}}
          tabIndex="0"
          role="button">
          <span className="plusiconadd">
            <FontAwesomeIcon icon={["far", "plus"]} />
          </span>
        </div>
      </Tooltip>
    </div>
  );

  _setAssetColumns = newAssetColumns => {
    this.setState(
      {
        assetColumns: newAssetColumns,
      },
      () => {
        writeDataToLocalStorage("assetCustomColumns", newAssetColumns);
      },
    );
  };

  _downloadMetadata = docIDs => {
    this.setState({
      showLoader: true,
      metalensLoaderMessage: "Extracting metadata...",
    });
    metadataBulkDownloadService(docIDs, "csv")
      .then(res => {
        downloadMetadataObject(res, "revv-bulk-metadata", "csv");
        this.setState({
          showLoader: false,
          showMetalensDownloadSuccessPopup: true,
          totalDocumentsDownloaded: docIDs.length,
          metalensLoaderMessage: "",
        });
      })
      .catch(() => {
        this.setState({
          showLoader: false,
          metalensLoaderMessage: "",
        });
        Toastr.showToastr({
          type: "failure",
          message: "Couldnot download metadata, Please try again",
          timeout: 3000,
        });
      });
  };

  _getAssetItemsActionHeader = () => {
    // const { isAllAssetItemsSelected } = this.state;
    const { count, selectedItems } = this._getSelectedItemData();
    return (
      <div className="assetdetails-row action-btns-row">
        <div className="assetdetails-col action-btns-left-section">
          <span className="action-btns-title">
            {count} {`${count > 1 ? "items" : "item"}`} selected
          </span>
        </div>
        <div className="assetdetails-col action-btns-right-section">
          <span
            className="action-btns-col"
            onClick={() =>
              this._toggleCustomLoader("showDeleteItemsPopup", true)
            }
            onKeyPress={() => {}}
            role="button"
            tabIndex="0">
            <FontAwesomeIcon
              icon={["far", "trash-alt"]}
              className="action-btns-icon delete-icon"
            />
            <span className="action-btns-title">Delete</span>
          </span>
          <span
            className="action-btns-col"
            onClick={() =>
              this._toggleCustomLoader("showMoveToFolderPopup", true)
            }
            onKeyPress={() => {}}
            role="button"
            tabIndex="0">
            <FontAwesomeIcon
              icon={["fas", "arrow-circle-right"]}
              className="action-btns-icon folder-icon"
            />
            <span className="action-btns-title">Move to folder</span>
          </span>
          <Tooltip
            placement="bottom"
            overlay="Use metalens to export metadata of the selected documents into a CSV"
            // align={{
            //   offset: [4, 0],
            // }}
          >
            <span
              className="action-btns-col"
              onClick={() => this._downloadMetadata(selectedItems.docIds)}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              {/* <FontAwesomeIcon
                icon={["fas", "microscope"]}
                className="action-btns-icon"
              /> */}
              <QuickReviewIcon />
              <span className="action-btns-title action-btns-title-metalens">
                Export Metadata
              </span>
              <span className="action-btns-new-tag">New</span>
            </span>
          </Tooltip>
        </div>
      </div>
    );
  };

  _toggleCreateDocPopUp = () => {
    this.setState(prevState => ({
      showCreateDocPopUp: !prevState.showCreateDocPopUp,
    }));
    if (!this.state.showCreateDocPopUp) {
      amplitudeLogEvent(EVENTS.EVENT_NAMES.CREATE_DOC_CLICKED, {
        initiatedFrom: "Asset",
      });
    }
  };

  _clearSearchTerm = () => {
    const { toggleSearchPage, assetClearSearchTerm } = this.props;
    toggleSearchPage(false);
    assetClearSearchTerm();
  };

  render() {
    const {
      selectedItem,
      showDeleteItemsPopup,
      selectedCheckboxItems,
      showMoveToFolderPopup,
      isAllAssetItemsSelected,
      showDeleteItemBtnLoader,
      showAssetItemRenamePopup,
      showCustomizeColumnPopup,
      showAssetCollaboratorPopup,
      assetColumns,
      showMetalensDownloadSuccessPopup,
      totalDocumentsDownloaded,
    } = this.state;
    const { currentSelectedFolder, showSearchPage, searchTerm } = this.props;
    const { isAnyItemSelected, selectedItems } = this._getSelectedItemData();
    let popupSpace = null;
    if (showDeleteItemsPopup) {
      popupSpace = (
        <ConfirmationBoxV2
          header="Are you sure you want to delete the selected items?"
          subHeader={`Once deleted, you won't be able to access.`}
          loaderMessage={DELETE_ITEM}
          showBtnLoader={showDeleteItemBtnLoader}
          closePopup={this._closeDeleteItemsPopup}
          checkboxLabel="Yes, I want to delete."
          confirmAction={() =>
            this._deleteAssetItems(selectedItem || selectedItems)
          }
          okBtnText="Delete"
        />
      );
    } else if (showMoveToFolderPopup) {
      popupSpace = (
        <AssetMoveToFolderPopup
          show={showMoveToFolderPopup}
          closePopup={this._toggleCustomLoader}
          selectedItems={selectedItem || selectedItems}
        />
      );
    } else if (showCustomizeColumnPopup) {
      popupSpace = (
        <AssetCustomizeColumnPopup
          show={showCustomizeColumnPopup}
          closePopup={this._toggleCustomLoader}
          setAssetColumnChanges={this._setAssetColumns}
          assetColumns={assetColumns}
        />
      );
    } else if (showAssetItemRenamePopup) {
      popupSpace = (
        <AssetItemRenamePopup
          show={showAssetItemRenamePopup}
          closePopup={this._toggleCustomLoader}
          selectedItem={selectedItem}
        />
      );
    } else if (showAssetCollaboratorPopup) {
      popupSpace = (
        <AssetCollaboratorPopup
          show={showAssetCollaboratorPopup}
          closePopup={this._toggleCustomLoader}
          selectedItem={selectedItem}
        />
      );
    } else if (showMetalensDownloadSuccessPopup) {
      popupSpace = (
        <MetalensBulkDownloadSuccessPopup
          totalDocs={totalDocumentsDownloaded}
          show={showMetalensDownloadSuccessPopup}
          closePopup={() => {
            this.setState({ showMetalensDownloadSuccessPopup: false });
          }}
        />
      );
    }

    let hasCheckboxPermission = true;
    let hasCreatePermission = true;
    if (currentSelectedFolder) {
      const { id, accessLevel } = currentSelectedFolder;
      if (id !== null) {
        hasCheckboxPermission = checkAssetPermission(accessLevel);
        const createType = accessLevel === "EDIT" ? "CREATE" : null;
        hasCreatePermission = checkAssetPermission(accessLevel, createType);
      }
    }

    let isChecked = false;
    if (hasCheckboxPermission) {
      if (selectedCheckboxItems.ALL) {
        isChecked = selectedCheckboxItems.ALL.flag;
      } else if (isAnyItemSelected) {
        isChecked = isAnyItemSelected;
      } else {
        isChecked = false;
      }
    }

    const assetItems = this.props.assetFolderContentIds;
    return (
      <Fragment>
        {/* Search Pill */}
        {showSearchPage ? (
          <AssetSearchTags
            searchTerm={searchTerm}
            clearSearchTerm={this._clearSearchTerm}
          />
        ) : null}
        <div className="assetdetails-tableheader-wrapper">
          <span className="assetdetails-checkbox-wrapper">
            <Input
              checked={isChecked}
              type="checkbox"
              value=""
              onChange={
                hasCheckboxPermission
                  ? () =>
                      this._selectAssetItem(
                        "ALL",
                        {
                          type: "ALL",
                          parentId: null,
                          flag: selectedCheckboxItems.ALL
                            ? !selectedCheckboxItems.ALL.flag
                            : true,
                        },
                        isAnyItemSelected,
                      )
                  : () => {}
              }
              disabled={!hasCheckboxPermission}
              className="assetdetails-checkbox-custom"
              data-test="assetdetails-checkbox-wrapper"
            />
          </span>
          {isAnyItemSelected
            ? this._getAssetItemsActionHeader()
            : this._getAssetItemsTableHeader()}
        </div>
        <div className="assetdetails-container">
          {popupSpace}

          {assetItems && assetItems.length > 0 && (
            <Fragment>
              <div className="asset-scrollable">
                <div className="assetdetails-assetitems-container">
                  <div className="assetdetails-assetitems-inner-wrapper">
                    {this.state.showLoader ? (
                      <Loader
                        className="asset-details-loader"
                        label={
                          this.state.metalensLoaderMessage || LOADING_MSG.FOLDER
                        }
                      />
                    ) : (
                      <AssetItems
                        assetItems={assetItems}
                        isAllAssetItemsSelected={isAllAssetItemsSelected}
                        isAnyItemSelected={isAnyItemSelected}
                        selectAssetItem={this._selectAssetItem}
                        toggleActionDropdown={this._openActionDropdown}
                        selectedCheckboxItems={selectedCheckboxItems}
                        assetColumns={assetColumns}
                        history={this.props.history}
                        showSearchPage={showSearchPage}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Fragment>
          )}

          {this.props.assetFolderContentIds &&
            !this.props.assetFolderContentIds.length &&
            !showSearchPage && (
              <div className="assetdetails-emptyscreen-wrapper">
                <FontAwesomeIcon
                  icon={["fal", "file-alt"]}
                  className="assetdetails-emptyscreen-ico"
                />
                <div className="assetdetails-emptyscreen-text">
                  <Fragment>
                    <span>You can create a new document here </span>
                    <span>or move an existing document into this folder</span>
                  </Fragment>
                </div>
                {hasCreatePermission ? (
                  <Button
                    className="assetdetails-emptyscreen-doc-create-btn"
                    onClick={this._toggleCreateDocPopUp}
                    data-test="assetdetails-emptyscreen-doc-create-btn">
                    <i>
                      <FontAwesomeIcon icon={["far", "plus"]} />
                    </i>
                    Create document
                  </Button>
                ) : (
                  <Tooltip
                    placement="top"
                    overlay="You do not currently have permission to create document in
                this folder"
                    align={{
                      offset: [4, 0],
                    }}>
                    <span>
                      <Button
                        disabled
                        className="assetdetails-emptyscreen-doc-create-btn">
                        <i>
                          <FontAwesomeIcon icon={["far", "plus"]} />
                        </i>
                        Create document
                      </Button>
                    </span>
                  </Tooltip>
                )}

                {showSearchPage && assetItems && !assetItems.length ? (
                  <div className="asset-search-no-results">
                    No results found
                  </div>
                ) : null}
                {this.state.showCreateDocPopUp && (
                  <AssetCreateDocumentPopup
                    isOpen
                    togglePopup={this._toggleCreateDocPopUp}
                    source="assets"
                  />
                )}
              </div>
            )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    assetFolderContent,
    assetFolderContentIds,
    currentSelectedFolder,
    searchTerm,
    currentView,
  } = state.AssetStore;
  return {
    assetFolderContent,
    assetFolderContentIds,
    currentSelectedFolder,
    searchTerm,
    currentView,
  };
};

const mapDispatchToProps = {
  getFolderContent: getAssetFolderContentAction,
  deleteAssetItems: deleteAssetItemsAction,
  assetClearSearchTerm: assetClearSearchTermAction,
  updateDocumentList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetDetails);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/index.js